import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
    Context as TBCContext,
    ChannelInterface
} from 'twitch-badge-collector-cc'

export default function Channel(props: { channel: ChannelInterface.ChannelInfoInterface }) {
    const { setChannel } = TBCContext.useChannelInfoContext();

    const onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
    }
    return (
        <ListItem 
            onClick={() => { setChannel({ type: 'login', value: props.channel.loginName }) }} 
            sx={{ width: '100%' }}
            secondaryAction={
                <Link onClick={onLinkClick} href={`/?channel=${props.channel.loginName}`} target='_blank'>
                    <IconButton edge="end" aria-label="delete">
                        <OpenInNewIcon />
                    </IconButton>
                </Link>
            }
            disablePadding
        >
            <ListItemButton>
                <ListItemAvatar>
                    <Avatar src={props.channel.profileImgUrl}>
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={props.channel.displayName} secondary={props.channel.category} />
            </ListItemButton>
        </ListItem>
    )
}
